module.exports = __webpack_public_path__ + "img/stars.85ed7ab.png";